<template>
  <main>
    <section class="container pt-5 pb-5">
      <div class="container content_padding text-white">
        <h4 class="pb-5">Order Inquiry</h4>
        <div class="row" style="justify-content: center;">
          <div class="col-md-8 row content_padding">
            <label class="order_lable">Customer
              No:</label>
            <input type="text" class="form-control order_input col-md-8" style="">
          </div>
          <div class="col-md-8 row content_padding">
            <label class="order_lable">Company:</label>
            <input type="text" class="form-control order_input col-md-8">
          </div>
          <div class="col-md-12 pt-5 text-center">
            <button class="btn custom-btn-primary" style="padding: 0.6rem 3rem;border-radius: 5px;">Search</button>
          </div>
        </div>
      </div>
    </section>

    <div class="table_container pb-5 text-left content_padding">
      <div id="PartNumberList" class="tabcontent">
        <table class="table table">
          <thead class="thead-dark">
            <tr>
              <th scope="col">No.</th>
              <th scope="col">Order Date</th>
              <th scope="col">Shipping Date</th>
              <th scope="col">Ready Date</th>
              <th scope="col">PI/CI No.</th>
              <th scope="col">P/O No.</th>
              <th scope="col">Shipped From</th>
              <th scope="col">Shipped To</th>
              <th scope="col">ERP Tracking No.</th>
              <th scope="col">Notes</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr>
              <td>1</td>
              <td>2025-01-05</td>
              <td>2025-03-15</td>
              <td style="background-color: #B70000;">2025-03-21</td>
              <td>SA250115001</td>
              <td>54099</td>
              <td>Foshan,China</td>
              <td>UK</td>
              <td>BJ2500115003</td>
              <td></td>
            </tr>
            <tr>
              <td>1</td>
              <td>2025-01-05</td>
              <td>2025-03-15</td>
              <td>2025-03-21</td>
              <td>SA250115001</td>
              <td>54099</td>
              <td>Foshan,China</td>
              <td>UK</td>
              <td>BJ2500115003</td>
              <td></td>
            </tr>
            <tr>
              <td>1</td>
              <td>2025-01-05</td>
              <td>2025-03-15</td>
              <td>2025-03-21</td>
              <td>SA250115001</td>
              <td>54099</td>
              <td>Foshan,China</td>
              <td>UK</td>
              <td>BJ2500115003</td>
              <td></td>
            </tr>
            <tr>
              <td>1</td>
              <td>2025-01-05</td>
              <td>2025-03-15</td>
              <td>2025-03-21</td>
              <td>SA250115001</td>
              <td>54099</td>
              <td>Foshan,China</td>
              <td>UK</td>
              <td>BJ2500115003</td>
              <td></td>
            </tr>
            <tr>
              <td>1</td>
              <td>2025-01-05</td>
              <td>2025-03-15</td>
              <td>2025-03-21</td>
              <td>SA250115001</td>
              <td>54099</td>
              <td>Foshan,China</td>
              <td>UK</td>
              <td>BJ2500115003</td>
              <td></td>
            </tr>
            <tr>
              <td>1</td>
              <td>2025-01-05</td>
              <td>2025-03-15</td>
              <td>2025-03-21</td>
              <td>SA250115001</td>
              <td>54099</td>
              <td>Foshan,China</td>
              <td>UK</td>
              <td>BJ2500115003</td>
              <td></td>
            </tr>
            <tr>
              <td>1</td>
              <td>2025-01-05</td>
              <td>2025-03-15</td>
              <td>2025-03-21</td>
              <td>SA250115001</td>
              <td>54099</td>
              <td>Foshan,China</td>
              <td>UK</td>
              <td>BJ2500115003</td>
              <td></td>
            </tr>
            <tr>
              <td>1</td>
              <td>2025-01-05</td>
              <td>2025-03-15</td>
              <td>2025-03-21</td>
              <td>SA250115001</td>
              <td>54099</td>
              <td>Foshan,China</td>
              <td>UK</td>
              <td>BJ2500115003</td>
              <td></td>
            </tr>
            <tr>
              <td>1</td>
              <td>2025-01-05</td>
              <td>2025-03-15</td>
              <td>2025-03-21</td>
              <td>SA250115001</td>
              <td>54099</td>
              <td>Foshan,China</td>
              <td>UK</td>
              <td>BJ2500115003</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>



      <div id="PartNumberList" class="tabcontent mt-5">
        <table class="table">
          <thead class="thead-dark">
            <tr>
              <th scope="col">No.</th>
              <th scope="col">Customer Part#</th>
              <th scope="col">Sanmak Part#</th>
              <th scope="col">Picture</th>
              <th scope="col">Part Description</th>
              <th scope="col">Ctn</th>
              <th scope="col">Qty</th>
              <th scope="col">Certificates</th>
              <th scope="col">Instructions</th>
              <th scope="col">PL</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr>
              <td>1</td>
              <td>0-420-85-WLAMP</td>
              <td style="color: #FCB42E;text-decoration: underline;">6069-009-013</td>
              <td><img src="/assets/img/Download/picture1.png" alt="" style="max-width: 5.5rem;max-height: 5.5rem;">
              </td>
              <td class="text-left">LED Indicator<br>
                Packaged Indicator/Park light w/ Male loom c/w connector 240mm</td>
              <td>5.00</td>
              <td>200.00</td>
              <td style="color: #FCB42E;text-decoration: underline;">1</td>
              <td style="color: #FCB42E;text-decoration: underline;">1</td>
              <td style="color: #FCB42E;text-decoration: underline;">1</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </main>
</template>

<script>
    export default {
        name: 'AfterMarket',

        computed: {},
        methods: {}
    };
</script>
<style scoped>
    @import '../../assets/css/main.css';
    :deep(.order_lable) {
        line-height: 2.6rem;
        text-align: right;
        padding-right: 1rem;
        width: 7.5rem;
    }
    
    @media (max-width: 768px) {
         :deep(.order_lable) {
            text-align: left;
        }
    }
    
    :deep(.order_input) {
        background-color: #89541E;
        border: 1px solid #242423;
        color: #fff;
    }
    
    :deep(.tabcontent) {
        max-height: 18rem;
        overflow-y: auto;
        text-align: center;
        -webkit-animation: fadeEffect 1s;
        animation: fadeEffect 1s;
    }
    
    :deep(.table) {
        width: 100%;
        border-collapse: collapse;
    }
    
    :deep(.table thead th) {
        position: sticky;
        top: 0;
        z-index: 2;
    }
    
    :deep(#PartNumberList table) {
        border: none;
        border-collapse: collapse;
    }
    
    :deep(#PartNumberList table th) {
        background-color: #434343;
    }
    
    :deep(#PartNumberList td) {
        border: none;
        height: 3rem;
    }
    
    :deep(#PartNumberList th) {
        border: none;
        height: 3rem;
    }
    
    :deep(#PartNumberList tr:nth-child(odd)) {
        background-color: #262625;
    }
    
    :deep(#PartNumberList tr:nth-child(even)) {
        background-color: #2F2F2E;
    }
    
    :deep(::-webkit-scrollbar) {
        width: 0.3rem;
        height: 0.3rem;
    }
    
    :deep(::-webkit-scrollbar-thumb) {
        background-color: #7E7E7C;
        border-radius: 4px;
    }
    
    :deep(::-webkit-scrollbar-thumb:hover) {
        background-color: #7E7E7C;
    }
    
    :deep(::-webkit-scrollbar-track) {
        background-color: #444442;
        border-radius: 4px;
    }
    
    :deep(.table_container) {
        width: 100%;
        margin-right: auto;
        margin-left: auto;
    }
    
    @media (min-width: 576px) {
         :deep(.table_container) {
            max-width: 576px;
        }
    }
    
    @media (min-width: 768px) {
         :deep(.table_container) {
            max-width: 768px;
        }
    }
    
    @media (min-width: 992px) {
         :deep(.table_container) {
            max-width: 992px;
        }
    }
    
    @media (min-width: 1200px) {
         :deep(.table_container) {
            max-width: 1200px;
        }
    }
    
    @media (min-width: 1920px) {
         :deep(.table_container) {
            max-width: 1680px;
        }
    }
</style>